/**
 * @author alexdkhu
 * 已知问题 1. alt加组合键在使用key模式下不可用
 *         2. ctrl加鼠标键不可用
 *         3. singleClick事件不可阻止
 */

// TODO 根据是否是新版浏览器看支持与否
import {
    on,
    remove,
} from '@utils/event';
import './key-event';
import './mouse-event';
import { convertKeyFromConfig } from './convert-key';
import { IpadExternalKeyboardEventManager } from './ipad-external-keyboard';

/**
 * 增加组合事件
 * @param {string} key 按键组合 shift+control+a
 * @param {function} cal 回调
 * @param {object} options // TODO
 */
export const addKeyMouseEvent = (key, cal, options?) => {
    on(convertKeyFromConfig(key, options), cal);
};

/**
 * 批量添加events
 */
export const addKeyMouseEvents = (config, options?) => {
    const keys = Object.keys(config);
    IpadExternalKeyboardEventManager.registerShortcutKeyEvent(keys);
    keys.forEach(key => addKeyMouseEvent(key, config[key], options));
};

export const removeMouseEvent = (key, cal, options?) => {
    remove(convertKeyFromConfig(key, options), cal);
};

export const removeMouseEvents = (config, options?) => {
    Object.keys(config).forEach(key => removeMouseEvent(key, config[key], options));
};
